// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width:480px){.max-width-layout[data-v-2d820c77]{max-width:500px;margin:0 auto}}@media screen and (min-width:960px){.max-width-layout[data-v-2d820c77]{max-width:850px;margin:0 auto}}.last-updated-text[data-v-2d820c77]{font-size:14px;font-weight:700}", ""]);
// Exports
module.exports = exports;
